import { type ReactElement } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { FloatingPopover } from '@/components/common/Floating'
import { type MenuOptionType } from '@/defs/input'
import { cn } from '@/utils/commonUtil'

import styles from './InputMenu.module.scss'
import { InputMenuList } from './InputMenuList/InputMenuList'

type Props = {
  'aria-label'?: string
  children: ReactElement
  className?: string
  options: MenuOptionType[]
  title?: string
  width?: 'maxcontent'
}

export const InputMenu = ({ children, className, options, width, ...props }: Props) => (
  <FloatingPopover content={<InputMenuList options={options} />} width='full'>
    <ButtonRoot className={cn(styles.button, { styles, width }, className)} {...props}>
      {children}
    </ButtonRoot>
  </FloatingPopover>
)
